exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-status-buy-order-js": () => import("./../../../src/pages/status/[buyOrder].js" /* webpackChunkName: "component---src-pages-status-buy-order-js" */),
  "component---src-pages-status-index-js": () => import("./../../../src/pages/status/index.js" /* webpackChunkName: "component---src-pages-status-index-js" */)
}

